// SPDX-License-Identifier: AGPL-3.0-or-later

import {useEffect, useState} from 'react';

export function useWalkPointerHint(container: HTMLElement | null, enabled: boolean): 'locked' | 'unlocked' | null {
	const [hint, setHint] = useState<'locked' | 'unlocked' | null>(null);
	useEffect(() => {
		setHint(null);
		if (!enabled || !container) return;
		const doc = container.ownerDocument;
		if (!doc.defaultView?.matchMedia('(any-pointer: fine)').matches) return;
		const canvas = container
			.closest('[data-flx="voice-scene.voice-scene-view.scene"]')
			?.querySelector('[data-flx="voice-scene.voice-scene-view.stage"] canvas');
		if (!canvas) return;
		let locked: boolean | undefined;
		let timeout: ReturnType<typeof setTimeout> | undefined;
		const update = () => {
			const next = doc.pointerLockElement === canvas;
			if (next === locked) return;
			locked = next;
			clearTimeout(timeout);
			setHint(locked ? 'locked' : 'unlocked');
			if (locked) timeout = setTimeout(() => setHint(null), 4000);
		};
		update();
		doc.addEventListener('pointerlockchange', update);
		return () => {
			clearTimeout(timeout);
			doc.removeEventListener('pointerlockchange', update);
		};
	}, [container, enabled]);
	return enabled ? hint : null;
}
